<template>
  <div>
    <!-- <my-header></my-header> -->
    <div class="container top-margin">
      <div class="is-size-2" style="padding-bottom: 20px">PRIVACY POLICY</div>
      <div class="text-left">
        <ol>
          <li>
            <b>INTRODUCTION</b>
            <br />
            <p>
              <b>Gigforce Private Limited,</b> a company incorporated under the
              Companies Act, 2013 vide CIN - U74999HR2019PTC082217, having its
              corporate office at House no 1872 Sector-2 BALLABHGARH Faridabad
              HR 121004 IN hereinafter referred to as the “<b>Company</b>” or
              “<b>We</b>” (which expression shall, unless it be repugnant to the
              context or meaning thereof, include its successors and assigns)
              owns and operates
              <a href="https://www.gigforce.in/"><u> www.gig4ce.com </u></a>
              (“<b>Website</b>”) and our application gig4ce (jointly referred to
              as “<b>Platform</b>”). Subject to the terms and conditions and
              user agreement set out on the Platform which shall be read along
              with this privacy policy (“<b>Privacy Policy</b>”), the Company
              shall make available through the Platform being an online
              aggregator platform and connecting medium for (i) persons to
              provide their work profiles, availability status and interest
              areas for rendering services in specific areas in time bound
              manner (“<b>Independent Consultants</b>” or “<b>IC</b>”); (ii) for
              corporate entities to provide their requirements of availing
              services of IC’s on specific assignments (“<b>Work Assignments</b
              >”) in regard to their business establishment (“<b
                >Requirement Listing Companies</b
              >”); (iii) third party service provider entities who are
              interested in rendering services including skill improvement
              seminars, e-workshops for enhancing professional skills,
              preparation of IC’s for interview and finalising of their work
              profile, insurances and social security, payroll services, pay
              roll compliance services, staffing service providers, legal and
              account related services etc. (“<b
                >Third Party Service Providers</b
              >”) in consideration of the subscription fee which may be fixed by
              the Company from time to time and reflected on the Platform while
              availing the services and as may be amended by the Company at its
              sole discretion from time to time (“<b>Subscription Fees</b>”) on
              the terms and conditions set out in the terms and conditions and
              user agreement on the Platform (“<b>Services”</b>). It is
              expressly clarified that the Company may render certain specific
              Services without any charges for a specific time period as may be
              deemed fit by the Company and which shall be notified on the
              Platform from time to time.
            </p>
            <br />
            <p>
              The terms and conditions, user agreement and the Privacy Policy
              shall together constitute the Agreement which the User will
              execute with the Company and shall always be read together for any
              purpose associated with the Services.
            </p>
            <br />
            <p>
              We understand the importance of protecting your privacy. We are
              committed to safeguarding the privacy of the personal identifiable
              information that We collect, possess, use, process, record, store,
              transfer, disclose, deal, handle and receive, by and on behalf of
              our Users (as defined under the Terms and Conditions set out on
              the Platform) while rendering Services to our Users through the
              Platform. Accordingly, set out below is our Privacy Policy setting
              out how we intend to safeguard such personal identifiable
              information received and used by us as aforesaid. This is in
              compliance with the prevailing Information Technology Act, 2000
              and the Information Technology (Reasonable Security Practices And
              Procedures And Sensitive Personal Data Or Information) Rules, 2011
              under the Information Technology Act, 2000 (“<b>IT Act</b>”).
            </p>
            <br />
            <p>
              The Company understands the importance of protecting the User’s
              privacy and is committed to safeguarding the privacy of the
              Sensitive Personal Information or Data that it collects,
              possesses, uses, processes, records, stores, transfers, discloses,
              deals with, handle and receives, by and on behalf of the User’s
              while rendering Services to the User’s. The Company intends to
              provide utmost security in respect to the Sensitive Personal
              Information or Data provided by the User and has complied with
              reasonable security practices and procedures.
            </p>
          </li>
          <br />
          <li>
            <b>SCOPE AND APPLICABILITY OF THIS POLICY</b>
            <br />
            <p>
              This privacy policy, as amended from time to time, ( “<b
                >Privacy Policy</b
              >”) is effective from <b>1st April, 2020</b> and applies to the
              Company, its affiliates and group companies, its employees, staff,
              team members, consultants, contractors, advisors, accountants,
              agents, person, representatives of the Company and/or service
              providers who collect, possess, use, process, record, store,
              transfer, disclose, deal, handle and receive, the personal
              identifiable information by and on behalf of the Users
              (“<b>You</b>” or “<b>Your</b>”) while rendering Services.
            </p>
            <p>
              This Policy summarizes what type of Personal Identifiable
              Information or PII (as defined hereinafter) which We collect about
              You, the purpose of such data collection, storage and usage of
              such data or information, to whom such data or information may be
              disclosed/transferred and how We protect Your privacy.
            </p>
          </li>
          <br />
          <li>
            <b>TYPES OF PERSONAL DATA OR INFORMATION WE COLLECT</b>
            <br />
            <p>
              The term “<b>Personal Identifiable Information or PII</b>” in this
              Policy refers to personal information which does and/or is capable
              of identifying You as an individual including sensitive personal
              data. The types of Personal Identifiable Information that We
              collect consist of personal and financial information relating to
              You:
            </p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  name, gender, home address, telephone number, date of birth,
                  marital status, email address, emergency contacts or other
                  contact information (including the gender, age, nationality
                  and passport information of any relatives and beneficiaries);
                  or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  affiliations, interests, work history, technical skills,
                  educational background, professional certifications and
                  registrations, language capabilities, or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  voicemails, e-mails, password, correspondence and
                  communications; or
                </p>
              </li>
              <li><p style="margin-left: 30px">password; or</p></li>
              <li>
                <p style="margin-left: 30px">
                  financial information such as Bank account or credit card or
                  debit card or other payment instrument details; or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  physical, physiological and mental health condition; or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">medical records and history; or</p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  biometric information; or location of the User in the event,
                  the User given access to the same.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  any detail relating to the above clauses as provided to the
                  Company; or
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  any of the information received under above clauses by the
                  Company for collecting, receiving, possessing, using,
                  processing, recording, storing, transferring, dealing,
                  handling and disclosing under lawful contract or otherwise.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  access to some of Your financial information as may be
                  provided by You for the purpose of accessing the Platform.
                  These information may include information which may also be in
                  the nature of being KYC information or personal financial
                  information which may be provided by the You, third party
                  API's or RTA feed etc., and received by the company. Wherever
                  such financial information is of the nature that even if
                  disclosed in isolation it will result in identification of the
                  person to whom such data pertains, it shall qualify as
                  Personal Identifiable Information and be classified as
                  Personal Identifiable Information and be treated in the same
                  manner and at the same standard as Personal Identifiable
                  Information is treated as per this Privacy Policy.
                </p>
              </li>
            </ul>
            <br />
            <p>
              This Policy does not apply to any information that You may
              disclose publicly and which is freely available or accessible in
              public domain or furnished under the Right to Information Act,
              2005 or any other law for the time being in force and such
              information shall not be regarded as Personal Identifiable
              Information for the purposes of this Policy. Further, Your
              Personal Identifiable Information shall not be disclosed to any
              third person unless the said third person is required to have the
              Personal Identifiable Information of Yours to provide required
              Services to You and/or with Your permission and/or to help
              investigate, prevent or take action regarding unlawful and illegal
              activities, suspected fraud, potential threat to the safety or
              security of any person, violations of the terms and conditions of
              use of the Platform or to defend against legal claims and special
              circumstances such as compliance with the rules of any stock
              exchange, subpoenas, court orders, requests/order from legal
              authorities or law enforcement agencies requiring such disclosure.
              We share Your information with advertisers on an aggregate basis
              only.
            </p>
            <br />
            <p>
              Further, any Personal Identifiable Information disclosed by the
              Users while connecting with each other through the Platform, the
              Company shall not be responsible and/or liable to treat the same
              as the Personal Identifiable Information to be protected by the
              Company.
            </p>
          </li>
          <br />
          <li>
            <b>YOUR CONSENT</b>
            <br />
            <p>
              You are providing Your consent by providing Your details at the
              time of registration on the Platform (“<b>Consent</b>”) with
              respect to the purpose of usage of such Personal Identifiable
              Information.
            </p>
            <br />
            <p>
              If You give Your Consent, it is construed that You have done so
              freely and voluntarily and agree to this Policy. You always have
              the right to refuse or withdraw Your Consent for the Personal
              Identifiable Information sought to be collected or withdraw Your
              Consent given earlier to us. We will always respect such a refusal
              or withdrawal, but this could affect Your use of Platform and We
              being unable to perform all the Services, arrangements or
              contracts with You and will have the option to discontinue the
              same. We will inform You of these inabilities, if they occur.
              However, We reserve the right to retain such Personal Identifiable
              Information as may be necessary for providing our pending Services
              to You and in accordance with this Policy and/or if legally
              required.
            </p>
            <br />
            <p>You are aware of the:</p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  fact that the Personal Identifiable Information is being
                  collected;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  contents and/or type of Personal Identifiable Information
                  which is being collected;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  purpose for which the Personal Identifiable Information is
                  being collected;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  intended recipients of the Personal Identifiable Information;
                  and
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  name and address of the agency that is collecting the Personal
                  Identifiable Information o, processing the said Personal
                  Identifiable Information and retaining the same.
                </p>
              </li>
            </ul>
            <br />
            <p>
              We respect Your privacy, therefore, the Company will observe the
              following guidelines when collecting, receiving, possessing,
              using, processing, recording, storing, transferring, dealing,
              handling, and disclosing:
            </p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be collected, received,
                  possessed, used, processed, recorded, stored, transferred,
                  dealt, handled and disclosed in compliance with the local
                  laws/regulations in India including IT Act and the rules
                  framed under the same;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be relevant/necessary
                  to/for the purposes for which it is collected and used;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be current and accurate
                  with reasonable steps taken by the Company to rectify or
                  delete inaccurate Personal Identifiable Information;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Personal Identifiable Information will be kept only as long as
                  necessary for the purposes for which it was collected and
                  processed; and
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  Reasonable measures will be taken to prevent unauthorized
                  access or use, unlawful processing, and unauthorized or
                  accidental loss, destruction, or damage to such Personal
                  Identifiable Information.
                </p>
              </li>
            </ul>
          </li>
          <br />
          <li>
            <b
              >PURPOSES FOR COLLECTION, STORAGE AND/OR USE OF PERSONAL DATA OR
              INFORMATION</b
            >
            <br />
            <p>
              The primary purposes for collection, storage and/or use of
              Personal Identifiable Information is for:
            </p>
            <!-- <br /> -->

            <ul>
              <li>
                <p style="margin-left: 30px">
                  our business processes, operations and management including
                  but not limited to performance of the business, operation of
                  the Services, entering into or performing any contract,
                  maintaining quality of the Services, providing support to the
                  Services You have obtained from us, managing company assets;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  processing Your order, corresponding with You, fulfilling Your
                  transaction requests and delivering the programs, information,
                  and Services requested by You or other Services related
                  inquiries;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  managing Client contacts profiles, administering and providing
                  You with information, services that You request from us or
                  which We feel may interest You,
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  record keeping and other general administrative and Services
                  related processes;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  ensuring the safety and protection of the rights or property
                  of the Company or its business;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  complying with applicable legal requirements in India
                  including but not limited to governmental reporting, etc. and
                  fulfilling statutory/legal obligations as a service provider
                  under applicable laws, adhering to judicial or administrative
                  orders, compliance with laws;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  contacting You via surveys to conduct research about Your
                  opinion of current Services or of potential new services that
                  may be offered by us;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  monitoring or recording of certain calls, chats and other
                  interactions relating to the online transactions which may
                  involve You calling us or us calling You and online chats for
                  staff training or quality assurance purposes or to retain
                  evidence of a particular transaction or interaction;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  while conducting daily business/operations such Personal
                  Identifiable Information may be provided to affiliates and
                  group companies, employees/staff of the Company and third
                  party's for the purpose of processing such Personal
                  Identifiable Information for or on our behalf including but
                  not limited to helping us to perform statistical analysis,
                  send You email or postal mail, provide clients and/or
                  prospective clients the support/support services, arrange for
                  deliveries of programs, information, and services, etc.;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  operating Platform, improving the content of our Platform to
                  offer You better Services and to ensure that content from our
                  Platform is presented in the most effective manner for You;
                  and in connection with the business of the Company.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  To personalize Your experience and provide content and Service
                  offerings that are best suited to Your interests;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  To allow us to better respond to Your specific service
                  requests;
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">To improve our Services;</p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  To overall analyze and understand Your behaviour by use of
                  data analytics to better Your experience and provide content
                  and Service offerings that are best suited to Your interests.
                  However, the results of which shall be considered our sole
                  intellectual property and proprietary know-how, and shall not
                  by virtue of use of Your data for the purpose of such analysis
                  grant any right of ownership of the end product to either You
                  or any of Your heirs or assigns or to any other third party.
                </p>
              </li>
            </ul>
            <br />
            <p>
              We shall, at all times, store Your Personal Identifiable
              Information in our cloud server storage (hosted and operated by
              external vendor such Google and Amazon) and to the best of our
              knowledge We understands that our external cloud storage vendors
              shall make best endeavor to ensure that such Personal Identifiable
              Information is safely stored clouds storages and shall be used for
              the purpose of business transactions only and shall be further
              protected and secured in compliance with the reasonable security
              practices and procedures.
            </p>
          </li>
          <br />
          <li>
            <b>DATA COLLECTION DEVICES</b>
            <br />
            <p>
              In addition to Personal Identifiable Information, We may use data
              collection devices such as “<b>cookies</b>” or other technology to
              obtain certain types of information when Your web browser accesses
              our Platform. Cookies are small files containing a string of
              characters to identify Your browser. Cookies allow the Platform to
              remember important data or information that will make Your visit
              to the Platform more useful. Our Platform may use cookies, web
              beacons and other similar invasive technology to store pertinent
              user information during a session to speed navigation and keep
              track of items and to collect anonymous traffic data that We may
              use to enhance our Platform and for marketing and promotional
              purposes. You can reset Your browser to refuse cookies or warn You
              when they are being sent. Please note that by turning cookies off,
              You may not have access to all features available on our Platform.
              We also use logging systems on our internal network to register
              the use of our computer systems. This is done for the purpose of
              ensuring the performance, integrity and security of these systems.
              We may also contract with third party’s to track and analyze
              anonymous usage and volume statistical information from our
              visitors and members for research purposes. Such information is
              shared externally only on an anonymous, aggregated basis. Such
              third party's use persistent cookies to help us to improve the
              visitor experience, to manage our Platform content, and to track
              visitor behaviour. All data or information collected by the
              Company is used solely by or on behalf of the Company and is
              shared externally only on an anonymous, aggregated basis.
            </p>
            <br />
            <p>
              We will make best efforts to do so but do not warrant that any of
              the third party platforms or any affiliate site(s) or network
              system linked to our Platform is free of any operational errors
              nor do We warrant that our Platform will be free of any virus,
              computer contaminant, worm, or other harmful components. Our
              Platform contains links to other sites which are not owned or
              operated by the Company. The Company is not responsible and makes
              no guarantee for the privacy practices or the content of such
              third party platforms. These links are provided only as a
              convenience to You. Neither, the Company nor any of its affiliates
              are responsible for the availability of such third party platforms
              or their contents. The Company will not be liable for Your
              Personal Identifiable Information transmitted over networks
              accessed by You on these sites or otherwise connected with Your
              use of the services. You understand, acknowledge and agree that
              neither the Company nor any of its affiliates are responsible or
              liable, directly or indirectly, for any damage or loss of any sort
              caused in connection with your use of or reliance on any content
              of any such site or services available through any such site.
            </p>
            <br />
            <p>
              You acknowledge that the Services, content, site and/ or any
              software are provided on an “<b>as is</b>” and “<b>as available</b
              >” basis, without warranties of any kind, either express or
              implied, including, without limitation, implied warranties of
              merchantability, fitness for a particular purpose. Although the
              Company has taken adequate safeguard and in case of any breach the
              Company may take action to remedy such breach. In addition to
              taking all the reasonable precautions as required under law, the
              Company expressly disclaims any and all warranties, express or
              implied, including, without limitation: (i) The Services and/ or
              software will be free of all viruses and hacking. (ii)The software
              will work on all mobile phones, will be compatible with all mobile
              phone networks and/or will be available in all geographical areas.
              (iii) Any service will be uninterrupted, timely, secure or
              error-free for any reasons whatsoever including but not limited to
              overload/breakdown of receiving network, servers or applications;
              system failures out of the Company’s control or due to heavy
              traffic on network.
            </p>
          </li>
          <br />
          <li>
            <b>DISCLOSURES OR TRANSFER OF YOUR PERSONAL DATA OR INFORMATION</b>
            <br />
            <p>
              The Company will transfer, with Your Consent, the Personal
              Identifiable Information to any other third party in India or
              overseas, that ensures the same level of data protection that is
              adhered to by the Company as set out herein for fulfilling any
              contractual obligation.
            </p>
            <br />
            <p>
              We will disclose or transfer Your Personal Identifiable
              Information in accordance with this Policy and all applicable
              legal requirements as applicable in India.
            </p>
            <br />
            <p>
              Your Personal Identifiable Information will be disclosed or
              transferred, as may be required from time to time, as follows:
            </p>
            <!-- <br /> -->
            <ul>
              <li>
                <p style="margin-left: 30px">
                  <b>For Business Purposes:</b>
                  to (i) the appropriate employees/staff/persons in our offices;
                  (ii) our affiliates and group companies; (iii) from one office
                  within the Company to another office in India or overseas in
                  accordance with the IT Act; (iv) to any third party, in the
                  event of a proposed or actual business transfer; (v) to the
                  Requirement Listing Companies, (vi) to Third Party Service
                  Providers, (vi) certified third party verification agencies
                  for the purpose of background and document verification at the
                  time of registration and (vii) in connection with our business
                  and Services provided by the Company.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  <b>To third party's:</b>
                  working with us or on our behalf in different industries and
                  categories of business. We will disclose, share, transfer Your
                  Personal Identifiable Information to any third party or
                  provide Your Personal Identifiable Information to any third
                  party in connection with our business requirements or for the
                  purposes indicated herein. Such third party's are required to
                  process Your Personal Identifiable Information they receive
                  from us in a lawful, safe and responsible manner in accordance
                  with this Policy and the prevailing laws and take all
                  appropriate security and confidentiality measures such that
                  they do not use Your Personal Identifiable Information for
                  their own purposes or disclose Your Personal Identifiable
                  Information or PII to others. Neither the Company nor any
                  third party will publish Your Personal Identifiable
                  Information.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  <b>For Legal Requirement:</b>
                  to any court of law and/or government agencies/entity as may
                  be required under law and/or statutory authority, Reserve Bank
                  of India and Credit Information Bureau India Ltd.
                  (“<b>CIBIL</b>”) or in response to a legal process, for the
                  purpose of verification of identity, or for prevention,
                  detection, investigation including cyber incidents,
                  prosecution, and punishment of offences and/or to any third
                  party by an order under the applicable law or if We determine
                  it is necessary or desirable to comply with any applicable
                  law, regulation, legal process or enforceable governmental
                  request or to protect or defend our rights or property
                  including compliance with accounting and tax rules and
                  regulations or to investigate, detect, prevent, or take action
                  regarding illegal activities, suspected fraud, security or
                  technical issues or situations involving potential threats to
                  the physical safety of any person.
                </p>
              </li>
              <li>
                <p style="margin-left: 30px">
                  <b>For Centralized Data Processing Activities:</b>
                  We have centralized certain aspects of our data processing and
                  administration in order to allow us to better manage our
                  business. Such centralization may result in the transfer of
                  Your Personal Identifiable Information: (i) from one country
                  to another; (ii) to our employees/staff of the
                  affiliates/group companies of the Company in other locations,
                  etc. However, whenever Your Personal Identifiable Information
                  or PII is transferred within the Company, it will be processed
                  in accordance with the terms and conditions of this Policy.
                </p>
              </li>
            </ul>
          </li>
          <br />
          <li>
            <b>REASONABLE SECURITY PRACTICES AND PROCEDURES AND AUDITS</b>
            <br />
            <p>
              We seek to ensure compliance with the requirements of the IT Act
              to ensure the protection and preservation of Your privacy,
              therefore We take reasonable security measures to protect Your
              Personal Identifiable Information against unauthorized access,
              alteration, disclosure or destruction. We have a number of
              physical, electronic, and procedural safeguards/measures in place
              to actively protect the confidentiality, security, and integrity
              of Your Personal Identifiable Information, including a
              comprehensively documented information security programme and a
              strict security policy that contains managerial, technical,
              operational and physical security control measures for protecting
              such data or information. We have implemented standard or code of
              best practices for data or information protection.
            </p>
            <br />
            <p>
              We limit access to Your Personal Identifiable Information to
              members of our team/employees of the Company/third party's who We
              believe reasonably need to come into contact with that information
              for the purpose of performing their duties and rendering services
              to You. We have strict confidentiality obligations that apply to
              such members/employees of the Company/third party's. Failure to
              meet these obligations may result in disciplinary and other
              actions, including dissolution of a contract, termination of
              employment and criminal prosecution.
            </p>
            <br />
            <p>
              We conduct training to authorized users regarding the lawful and
              intended purposes of processing Your Personal Identifiable
              Information , the need to protect and keep information accurate
              and upto-date and the need to maintain the confidentiality of the
              data or information to which such authorized users have access.
              Authorized users will comply with this Policy, and We will take
              appropriate disciplinary actions, in accordance with applicable
              laws in India, if Your Personal Identifiable Information is
              accessed, processed, or used in any way that is inconsistent with
              the requirements of this Policy.
            </p>
          </li>
          <br />
          <li>
            <b>RETENTION OF YOUR PERSONAL DATA OR INFORMATION</b>
            <br />
            <p>
              We are aware of the importance of timely destruction of Personal
              Identifiable Information. We ensure that Your Personal
              Identifiable Information is not stored/retained for a longer
              period than necessary for the purpose for which it was collected,
              used or processed or as provided in our contracts except when
              there is a legal obligation to do so under any law in India. It is
              our practice to destroy Your Personal Identifiable Information as
              soon as possible after it is no longer necessary for the purpose
              for which it was collected, used or processed save and except as
              stated hereinabove.
            </p>
          </li>
          <br />
          <li>
            <b
              >UPDATING OR REVIEWING YOUR PERSONAL DATA OR INFORMATION/
              QUESTIONS OR COMPLAINTS</b
            >
            <br />
            <p>
              You may by a written request review the Personal Identifiable
              Information provided by You. We will ensure that any Personal
              Identifiable Information about You which is found to be inaccurate
              or deficient shall be corrected or amended as may be feasible.
            </p>
            <br />
            <p>
              You expressly state that Personal Identifiable Information
              provided by You to us is correct and complete in all respects and
              does not contain any false, distorted, manipulated, fraudulent or
              misleading facts. We expressly disclaim any liability arising out
              of the said data or information provided by You to us. Further,
              You expressly agree that We are not responsible for the accuracy
              and authenticity of such data or information provided by You to us
              and You agree to indemnify the Company for all losses incurred by
              the Company due to any false, distorted, manipulated, defamatory,
              libelous, vulgar, obscene, fraudulent or misleading facts made by
              You to the Company.
            </p>
            <br />
            <p>
              In case of any discrepancies or grievances with regard to the
              processing of Your Personal Identifiable Information, please
              contact the “<b>Grievance Officer – Anirudh Syal</b>” at
              <a href="mailto:complaints@gig4ce.com"
                ><u> complaints@gig4ce.com </u></a
              >. Further on receipt of any concerns or complaints the Grievance
              Officer will employ all commercially reasonable efforts to address
              the same within One (1) month of receipt of same.
            </p>
          </li>
          <br />
          <li>
            <b>ENFORCEMENT RIGHTS</b>
            <br />
            <p>
              All the Company’s affiliates/group companies will ensure that this
              Policy is observed. All employees/staff of the Company and Third
              Parties who have access to Personal Identifiable Information are
              required to comply with this Policy.
            </p>
            <br />
            <p>
              All third party's shall only process the Personal Identifiable
              Information in accordance with the Company's instructions or make
              decisions regarding such data or information as part of the
              delivery of their services. In either instance, the Company will
              select reliable third parties who undertake, by contract or other
              legally binding and permissible means, to put in place appropriate
              technical and organizational security measures to ensure an
              adequate level of protection of such data or information. The
              Company will require third party's to comply with this Policy or
              to guarantee the same levels of data protection that is adhered to
              by the Company when handling/processing such data or information.
              Such selected Third Party's will have access to such data or
              information solely for the purposes of performing the services
              specified in the applicable service contract and are legally and
              contractually bound to maintain the privacy of such data or
              information shared with them and will not disclose it further. If
              the Company concludes that a third party is not complying with
              these obligations, it will promptly take appropriate actions to
              remedy such non-compliance or implement necessary sanctions.
            </p>
            <br />
            <p>
              Additionally, our team members/employees/staff are bound by
              internal confidentiality standards and policies. Any team
              member/employee/staff found to have violated this Policy or any
              other policies will be subject to strict disciplinary action, up
              to and including termination of employment including penalties
              under applicable laws in India.
            </p>
            <br />
            <p>
              All third parties and our team members/employees/staff do hereby
              specifically agree that he/she/it shall, at all times, comply with
              the requirements of the IT Act, while collecting, receiving,
              possessing, using, processing, recording, storing, transferring,
              dealing, handling and disclosing Personal Identifiable
              Information. The said third parties and team
              members/employees/staff do further unequivocally declare that in
              case he/she/it violates any provisions of the IT Act, he/she/it
              shall alone be responsible for all his/her/it acts, deeds and
              things and that he/she/it alone shall be liable for civil and
              criminal liability there under or under any applicable Indian law
              for the time being in force.
            </p>
          </li>
          <br />
          <li>
            <b>MODIFICATIONS TO THE POLICY</b>
            <br />
            <p>
              The Company reserves the right to update, change or modify this
              Policy, from time to time, without prior notification. The Policy
              shall come into effect from the date of such update, change or
              modification.
            </p>
            <br />
            <p>
              We will inform You regarding any such changes by updating this
              Policy and will post all changes to the Policy on relevant place
              on the Platforms.
            </p>
            <br />
            <p>
              Effective with the implementation of this Policy, all existing
              intra-group agreements and the applicable Company privacy
              guidelines or practices relating to the processing of Personal
              Identifiable Information will be superseded by the terms of this
              Policy and modified accordingly. All parties to any such
              agreements will be notified of the effective date of
              implementation of the Policy.
            </p>
            <br />
            <p>
              If any of the terms or definitions used in this Policy are
              ambiguous, the definitions established under the IT Act and the
              rules formulated under the scheme of the IT Act, shall apply.
            </p>
          </li>
        </ol>
        <br />
        <br />

        <div style="text-align: center; font-size: 20px; padding-bottom: 20px">
          <b
            ><u>
              Terms & Conditions and User Agreement for transacting at and/or
              dealing with the Platform
            </u></b
          >
          <br />
          <a href="https://www.gigforce.in/"
            ><b><u> www.gig4ce.com </u></b></a
          >
        </div>

        <ol type="I">
          <b><li>Recitals</li></b>
          <br />
          <ol>
            <li>
              This document is an electronic record in terms of Information
              Technology Act, 2000 and rules there under as applicable and the
              amended provisions pertaining to electronic records in various
              statutes as amended by the Information Technology (Amendment) Act,
              2008. This electronic record is generated by a computer system and
              does not require any physical or digital signatures. This
              electronic record is generated by a computer system and does not
              require any physical or digital signatures.
            </li>
            <br />
            <li>
              This document is published in accordance with the provisions of
              Rule 3 (1) of the Information Technology (Intermediaries
              Guidelines) Rules, 2011 that require publishing the rules and
              regulations, privacy policy and user agreement for access or usage
              of <a href="https://www.gigforce.in/"><u> www.gig4ce.com </u></a>
            </li>
            <br />
            <li>
              <a href="https://www.gigforce.in/"><u> www.gig4ce.com </u></a>
              (“<b>Website</b>”) and our mobile application gig4ce (jointly
              referred to as “<b>Platform</b>”) is owned and operated by
              Gigforce Private Limited, a company incorporated under the
              Companies Act, 2013 vide CIN - U74999HR2019PTC082217, having its
              corporate office at House no 1872 Sector-2 Ballabhgarh Faridabad
              Haryana India-121004. hereinafter referred to as the
              “<b>Company</b>” (which expression shall, unless it be repugnant
              to the context or meaning thereof, include its successors and
              assigns).
            </li>
            <br />
            <li>
              Subject to the terms and conditions of this Agreement (as defined
              hereinafter), the Company shall make available through the
              Platform being an online aggregator platform and connecting medium
              for (i) persons to provide their work profiles, availability
              status and interest areas for rendering services in specific areas
              in time bound manner (“<b>Independent Consultants</b>'' or
              “<b>IC</b>”); (ii) for corporate entities to provide their
              requirements of availing services of IC’s on specific assignments
              (“<b>Work Assignments</b>”) in regard to their business
              establishment (“<b>Requirement Listing Companies</b>”); (iii)
              third party service provider entities who are interested in
              rendering services including skill improvement seminars,
              e-workshops for enhancing professional skills, preparation of IC’s
              for interview and finalising of their work profile, insurances and
              social security, payroll services, pay roll compliance services,
              staffing service providers, legal and account related services,
              credit score checks and background checks etc. (“<b
                >Third Party Service Providers</b
              >”) making available the information being uploaded by IC,
              Requirement Listing Companies and Third Party Service Providers
              and enabling parties to have better access to services and/or
              service providers in consideration of the subscription fee which
              may be fixed by the Company from time to time and reflected on the
              Platform while availing the services and as may be charged by the
              Company at its sole discretion from time to time (“<b
                >Subscription Fees</b
              >”) on the terms and conditions set out herein
              (“<b>Services</b>”).
            </li>
            <br />
            <li>
              It is expressly clarified that the Company may render certain
              specific Services without any charges for a specific time period
              as may be deemed fit by the Company and which shall be notified on
              the Platform from time to time. It is expressly stated that the
              User shall be solely responsible and liable for the information,
              images and data uploaded by the User. The Company has the absolute
              right, at any time, to render the Services being offered through
              the Platform through any party whatsoever.
            </li>
            <br />
            <li>
              Use of this Platform is regulated by terms and conditions provided
              herein. By clicking on the “<b>I ACCEPT</b>” button, you are
              consenting to be bound by these Agreement and please ensure that
              you read and understand all these user terms before you use the
              Platform. If you do not accept any of the user terms, then please
              do not use the site or avail any of the services being provided
              therein. Your agreement to these user terms shall operate as a
              binding agreement between you and the Company in respect of the
              use and services of the Platform. Your access, visit, dealing,
              transacting and/or otherwise using this Platform shall be treated
              as your unconditional acceptance of these terms in entirety and
              the same shall be deemed that you have accepted these terms fully
              and you have gone through and understood these terms completely
              and these terms shall be treated as a legally binding and
              enforceable Agreement between the Company and you
              (“<b>Acceptance</b>”). If you do not agree with any of these terms
              or all of these terms, then you should stop dealing with and/or
              not initiate or undertake any transaction on this Platform.
            </li>
            <br />
            <li>
              The information and Services offered on this Platform or through
              other mediums should not be considered as a substitute for
              professional advice. The User's use of the Platform and/or
              Services is subject to the additional disclaimers and caveats that
              may appear throughout the Platform. The Company, its associate
              companies, subsidiaries assume no responsibility for any
              consequence relating directly and/or indirectly to any action
              and/or inaction that the User takes based on the information,
              Services and other materials on this Platform. While the Company
              strives to keep the information relating to the various Services
              offered on this Platform accurate, complete and up-to-date, the
              Company, its subsidiaries, affiliates, associate companies,
              consultants, partners, agents and suppliers cannot guarantee, and
              will not be responsible for any damage and/or loss related to, the
              accuracy, completeness or timelines of the information.
              <br />
              It is expressly provided that the data pertaining to the Services
              offered through the Platform is provided by third parties and the
              same is not owned by the Company.
            </li>
            <br />
            <li>
              The Company may change, suspend and/or discontinue the Services at
              any time, including the availability of any feature, database and
              content on the Platform. The Company may also impose limits on
              certain features and Services and/or restrict the User's access to
              parts and/or all of the Services without notice and/or liability
              to the Users.
            </li>
            <br />
            <li>
              All kinds of correspondence should be addressed to the Company's
              office address as given above.
            </li>
          </ol>
          <br />
          <b><li>TERMS AND CONDITIONS</li></b>
          <br />
          <ol>
            <b><li>Definitions</li></b>
            <p>
              The words and phrases used in these terms are defined as under
              unless repugnant to the context or meaning thereof:
            </p>
            <p>
              “<b>Acceptance</b>” shall have the meaning ascribed to it in
              Recital I (5).
            </p>
            <p>
              “<b>Agreement</b>” shall mean this agreement between the Company
              and the User with terms and conditions as provided herein and
              includes the Privacy Policy and all schedules, appendices and
              references mentioned herein with all such amendments as effected
              by the Company from time to time.
            </p>
            <p>
              “<b>Company</b>” shall have the meaning ascribed to it in Recital
              I (3).
            </p>
            <p>
              “<b>Independent Consultant</b>” or “IC” shall have the meaning
              ascribed to it in Recital I (4).
            </p>
            <p>
              “<b>Intellectual Property Rights</b>” shall have the meaning
              ascribed to it in Clause 4.2(a).
            </p>
            <p>
              “<b>Marks</b>” shall have the meaning ascribed to it in Clause
              4.2(e).
            </p>
            <p>
              “<b>Platform</b>” shall have the meaning ascribed to it in Recital
              I (3).
            </p>
            <p>
              “<b>Requirement Listing Companies</b>” shall have the meaning
              ascribed to it in Recital I (4).
            </p>
            <p>
              “<b>Subscription Fee</b>" shall have the meaning ascribed to it in
              Recital I (4).
            </p>
            <p>
              “<b>Services</b>” shall have the meaning ascribed to it in Recital
              I (4).
            </p>
            <p>
              “<b>Third Party Content</b>” shall have the meaning ascribed to it
              in Clause 5.1.
            </p>
            <p>
              “<b>Third Party Service Provider</b>” shall have the meaning
              ascribed to it in Recital I (4).
            </p>
            <p>
              “<b>User</b>” shall mean any person including IC and/or an
              authorized personnel of a legal entity including Requirement
              Listing Companies, Third Party Service Providers that visits,
              uses, deals with and/or transacts on the Platform in any way. Any
              references herein to 'you' and 'your' shall mean the User.
            </p>
            <p>
              “<b>ser Content</b>” shall have the meaning ascribed to it in
              Clause 5.3
            </p>
            <p>
              “<b>Platform</b>” shall have the meaning ascribed to it in Recital
              I (3).
            </p>
            <p>
              “<b>Work Assignments</b>” shall have the meaning ascribed to it in
              Recital I (4).
            </p>
            <p>
              “<b>Web Links</b>” shall have the meaning ascribed to it in Clause
              XI
            </p>
            <p>
              In this Agreement, the ‘<b>Company</b>’ and the ‘<b>User</b>’ have
              been collectively referred to as “<b>Parties</b>” and individually
              as “<b>Party</b>”.
            </p>

            <b><li>Eligibility</li></b>
            <div style="display: flex">
              <p>2.1</p>
              <p style="margin-left: 10px">
                The User hereby represents and warrants that the User is at
                least Eighteen (18) years of age and the User’s visit, access,
                dealing and/or transaction at the Platform shall be treated as
                the User’s representation that the User is competent to enter
                into legal contracts under applicable law including the Indian
                Contract Act, 1872.
              </p>
            </div>
            <div style="display: flex">
              <p>2.2</p>
              <p style="margin-left: 10px">
                If the User is availing of the Services, the User further
                warrants that the User has legal authority to enter into legally
                binding agreements for the same. The User agrees to be
                financially responsible for all of the User’s use of the
                Services and access of the Platform (as well as for use of the
                User’s account by others). The User also warrants that all
                information supplied by the User in availing the Services and
                accessing the Platform, including without limitation the Users
                Content, the User’s name, email address, street address,
                telephone number, mobile number, credit/debit card number and
                other payment details is correct and accurate. Failure to
                provide accurate information may subject the User to civil and
                criminal penalties. This Agreement and/or any of the provision
                is void by law, and the right to access the Platform is revoked
                in such jurisdictions.
              </p>
            </div>
            <div style="display: flex">
              <p>2.3</p>
              <p style="margin-left: 10px">
                The User acknowledge and agree that the Services being provided
                through the Platform are only connecting services being an
                aggregator platform reflecting information uploaded by Users and
                enabling parties to have better access to services and/or
                service providers and the Company has not verified the veracity
                of any information and disclosures being made by such third
                parties except as set out herein and the inter-connection
                between the Users shall be governed by terms and conditions
                agreed between the Users i.e. IC, Requirement Listing Companies
                and Third Party Service Providers (as may be applicable) and the
                Company is not a party to such arrangement and accordingly shall
                not be responsible and/or liable whether financially or
                otherwise in regard to such inter-connection.
              </p>
            </div>

            <b><li>Amendment of Terms</li></b>
            <p>
              The Company is entitled to amend these terms anytime without any
              prior intimation to anybody and simply by way of notification on
              the Platform. The User shall be responsible for reviewing and
              becoming familiar with any such modifications/amendments from time
              to time and shall be bound to this Agreement as amended by the
              Company from time to time. Use of the Services by the User
              following such notification constitutes the User’s acceptance of
              the terms and conditions of this Agreement as modified.
            </p>

            <b><li>Intellectual Property</li></b>
            <p>4.1 <b style="margin-left: 10px">Platform Content</b></p>
            <div style="display: flex; margin-left: 30px">
              <p>(a)</p>
              <p style="margin-left: 10px">
                The User acknowledges and agrees that the Company retains all
                right, title, ownership and interest in and to the Platform, all
                data and information, content, articles, material, text,
                literature, images, illustrations, photographs, videos,
                clippings, graphics, scripts, page headers, sounds, music,
                interactive features, the selection and arrangement of elements,
                the compilation, layout, design, software, domain name, business
                process, procedures, in any form whatsoever including but not
                limited to, print, writing, oral, electronic, digital/IT
                enabled, in machine readable and/or in any other form, and all
                patent rights, copyright rights, trademark rights, service mark
                rights, trade secret rights and other intellectual property
                rights therein recognized anywhere in the world (“<b
                  >Intellectual Property Rights</b
                >”), other than rights in Third Party Content or User Content.
                All use of such rights, including the Intellectual Property
                Rights, in any manner, medium or mode shall perpetually and
                throughout the world legally vest in the Company at all times
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(b)</p>
              <p style="margin-left: 10px">
                Payment of the Subscription Fee by the User to the Company for a
                particular Service merely grants the User a non-exclusive,
                temporary, revocable and conditional license to access and avail
                the Service for a given period of time.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(c)</p>
              <p style="margin-left: 10px">
                All Intellectual Property Rights of the Company is a valuable
                asset of the Company and the User agrees to protect, preserve
                and maintain confidentiality of the same. The User acknowledges
                that any unauthorized dissemination of the Intellectual Property
                Rights of the Company would destroy or diminish its value and
                cause irreparable harm and loss to the Company, and that
                monetary damages will be inadequate to compensate the Company
                for any breach thereof. The User, therefore, agrees that the
                Company shall, in addition to its rights in law and equity
                including to its right to claim damages, have the right to seek
                immediate injunctive relief and specific performance to enforce
                the obligations contained herein.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(d)</p>
              <p style="margin-left: 10px">
                The Platform is protected by copyright as a collective work
                and/or compilation, pursuant to Indian Copyright laws,
                international conventions, and other worldwide copyright laws.
                The User is not authorized to reproduce, republish, distribute,
                transmit, modify, edit, sell, transfer, license, translate,
                communicate, publish, use or exploit the Platform and/or its
                content in any manner whatsoever, or create derivative works
                based on it, in whole or in part, without the Company’s express
                written authorization, which the Company is under no obligation
                to grant.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(e)</p>
              <p style="margin-left: 10px">
                Any logo, trademark, brand name, service mark, trade name,
                slogan, and other indicia (“<b>Marks</b>”) that appear on or in
                connection with the Platform and/or its content, is the
                intellectual property of the Company. The Company expressly
                reserves all rights therein and the User agrees not to display,
                use or exploit the same in any manner whatsoever. Nothing
                contained in this Platform should be construed as granting, by
                implication, estoppels, or otherwise, any license or right in
                and to the Marks.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(f)</p>
              <p style="margin-left: 10px">
                The User’s misuse of the Platform and/or its content and/or its
                Marks, is strictly prohibited. The User is advised that the
                Company will aggressively enforce its Intellectual Property
                Rights and/or the contents of the Platform to the fullest extent
                permissible by law, including by seeking appropriate remedies
                including criminal sanctions solely at the User’s risk as to
                costs and consequences. The Company has all the rights to
                disable or prohibit access to the Users who do not abide by
                these terms and are involved in the infringement of our
                intellectual property.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(g)</p>
              <p style="margin-left: 10px">
                All the information and content disclosed on the Platform except
                the Third Party Content and User Content is proprietary in
                nature and solely belongs to the Company and its respective
                licensors and shall not be used and/or copied and/or tampered
                with in any manner (as the case may be).
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(h)</p>
              <p style="margin-left: 10px">
                The Users hereby further acknowledge that any views and/or
                opinions offered by any expert and/or advisory panel on the
                Platform through any webinars, workshops etc is such expert /
                advisory panels own view and/or opinion and does not express the
                Company’s view and / or opinion and the Company shall bear no
                liability (financial or otherwise) with respect to the same.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(i)</p>
              <p style="margin-left: 10px">
                The Users hereby acknowledge that the Company reserves the right
                to list its registered Users on the Platform and on other online
                portals operated by the Company or its affiliates. In case a
                User does not want to be listed on any such sites or any of the
                other such online portals, they can communicate the same to the
                Company in writing by sending an email to
              </p>
            </div>

            <b><li>Third Party Content and User Content</li></b>
            <div style="display: flex">
              <p>5.1</p>
              <p style="margin-left: 10px">
                The User hereby acknowledges that there may be publishers,
                advertisement agencies, other corporates, persons and legal
                entities who may upload third party trademarks, logos,
                photographs, images, content and other intellectual property
                rights on the Platform (“<b>Third Party Content</b>”). The
                Company shall not be responsible and/or liable for any Third
                Party Content.
              </p>
            </div>
            <div style="display: flex">
              <p>5.2</p>
              <p style="margin-left: 10px">
                The Users hereby agrees and acknowledges that the Third Party
                Content are the properties of the respective third parties and
                the same may be protected by applicable copyright, trademark or
                other intellectual property laws and treaties and each such
                third party expressly reserves all the rights to such
                intellectual property.
              </p>
            </div>
            <div style="display: flex">
              <p>5.3</p>
              <p style="margin-left: 10px">
                The Users such as IC, Requirement Listing Companies and the
                Third Party Service Providers shall be uploading images, data
                and other information owned or licensed to such Users on the
                Platform as part of the Services rendered through the Platform
                (“<b>User Content</b>”). The User hereby represents and warrants
                that the User Content is owned by such User or the User has the
                license to use such User Content and upload the same on the
                Platform. Further, User uploading such User Content hereby
                acknowledge that the same is being done at the sole discretion
                and risk of the User and if such User Content is collected by a
                third party using the Platform which is misused or results in
                unsolicited messages from such third parties, then such actions
                would be beyond the control of the Company and the Company
                accepts no responsibility or liability whatsoever for such
                actions.
              </p>
            </div>
            <div style="display: flex">
              <p>5.4</p>
              <p style="margin-left: 10px">
                The Company shall have the right to scan, filter, block and
                verify the Third Party Content and User Content for virus, bugs
                and other such software malware and retains the right to remove
                any Third Party Content and/or User Content at its sole
                discretion. Further, the Company shall make best efforts to
                filter the data, information and images in accordance with
                applicable laws.
              </p>
            </div>
            <div style="display: flex">
              <p>5.5</p>
              <p style="margin-left: 10px">
                Certain elements of the Platform may contain material submitted
                by other Users and/or third parties. The Company disclaims its
                responsibility for the content, accuracy, conformity to
                applicable laws of such material including advertising material
                forming part of the Platform. Responsibility for ensuring that
                material submitted for inclusion on the Platform complies with
                applicable laws is exclusively on the advertisers and third
                parties and the Company will not be responsible for any claim,
                error, omission and/or inaccuracy arising out of or in relation
                to such material. The Company reserves the right to omit,
                suspend and/or change the position of any material submitted for
                insertion on the Platform. Acceptance of advertisements on the
                Platform shall be subject to the Company’s terms and conditions
                applicable to advertisements.
              </p>
            </div>
            <div style="display: flex">
              <p>5.6</p>
              <p style="margin-left: 10px">
                The User shall abide by all copyright notices, intellectual
                property rights, information and restrictions contained in any
                content accessed through the Services.
              </p>
            </div>

            <b><li>Registration Data</li></b>
            <div style="display: flex">
              <p>6.1</p>
              <p style="margin-left: 10px">
                The User shall be entitled to use the Platform for any purpose
                set out therein after getting registered on the Platform and
                after furnishing all relevant information relating to the User
                as sought on the Platform. The User shall be solely responsible
                for maintaining and preserving the confidentiality of its User
                Id and Password.
              </p>
            </div>
            <div style="display: flex">
              <p>6.2</p>
              <p style="margin-left: 10px">
                The User shall be solely responsible for the accuracy and
                correctness of all such detail/information given by the User
                during registration. The Company may at its sole discretion
                verify those details, if it deems fit. If the Company has reason
                to doubt the correctness and/or authenticity of any
                detail/information furnished by the User or in case any
                information furnished by the User is found incorrect, false or
                misleading then the Company shall be entitled to cancel or
                suspend the registration of the User permanently or for such
                period as the Company deems fit.
              </p>
            </div>
            <div style="display: flex">
              <p>6.3</p>
              <p style="margin-left: 10px">
                The User hereby grants the Company the right to use the
                information the User supplies to the Company for the purpose of
                the Services and conducting background and credit check wherever
                deemed necessary. The User hereby agrees to grant the Company a
                non-exclusive, fully paid and royalty-free, transferable,
                sub-licensable, worldwide license and right to exercise the
                copyright, publicity, and database rights the User has in
                his/her information, in any media now or in future known, with
                respect to the User’s information.
              </p>
            </div>
            <div style="display: flex">
              <p>6.4</p>
              <p style="margin-left: 10px">
                The User confirms that the Company shall not be responsible for:
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(a)</p>
              <p style="margin-left: 10px">
                Any deficiency in Service for reasons which are attributable to
                the User.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(b)</p>
              <p style="margin-left: 10px">
                Any loss and/or damage to the User due to incorrect, incomplete
                and/or false information furnished by the User.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(c)</p>
              <p style="margin-left: 10px">
                Any technical or non-technical payment related snags which the
                User may face through the use of the third-party payment
                gateways as provided by the Company on the Platform. Any
                deficiency in payment of consideration payable by the Users
                connected through the Platform, shall not be the responsibility
                of the Company and the Company shall not be directly or
                indirectly be held liable in respect to the same.
              </p>
            </div>
            <div style="display: flex">
              <p>6.5</p>
              <p style="margin-left: 10px">
                The User shall be liable to be prosecuted and/or punished under
                applicable laws for furnishing false, incorrect, incomplete
                and/or misleading information to the Company.
              </p>
            </div>

            <b
              ><li>
                Representation, Warranties, Acknowledgement, Covenants,
                Undertakings And Obligations
              </li></b
            >
            <div style="display: flex">
              <p>7.1</p>
              <p style="margin-left: 10px">
                The User represents and warrants that it has the legal capacity
                and authority to enter into this Agreement, register on the
                Platform and that the User is the owner and/or authorized to
                share the information the User gives on the Platform. The User
                confirms that the information is correct, complete, accurate,
                not misleading, does not violate any statutory enactment,
                notification, order, circular, policy, rules and regulations, is
                not injurious to any person and/or property.
              </p>
            </div>
            <div style="display: flex">
              <p>7.2</p>
              <p style="margin-left: 10px">
                The User acknowledges and understands that the Company does not
                have any control on accuracy of information/detail submitted by
                anybody on the Platform and therefore agrees that the Company
                shall not be responsible for any loss, damage, cost, expenses,
                etc. due to inaccuracy of any detail/information submitted by
                the User or anybody else on the Platform.
              </p>
            </div>
            <div style="display: flex">
              <p>7.3</p>
              <p style="margin-left: 10px">
                The User represents, warrants and covenants that information
                submitted by the User:
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(a)</p>
              <p style="margin-left: 10px">
                is correct, complete, relevant and accurate;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(b)</p>
              <p style="margin-left: 10px">is not fraudulent;</p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(c)</p>
              <p style="margin-left: 10px">
                does not and shall not infringe any third-party’s intellectual
                property, trade secret and/or other proprietary rights and/or
                rights of publicity and/or privacy;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(d)</p>
              <p style="margin-left: 10px">
                shall not be defamatory, libelous, unlawfully threatening and/or
                unlawfully harassing;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(e)</p>
              <p style="margin-left: 10px">
                shall not be indecent, obscene and/or contain pornography and/or
                contain any thing which is prohibited under any prevailing laws,
                rules & regulations, order of any court, forum, statutory
                authority;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(f)</p>
              <p style="margin-left: 10px">
                shall not be seditious, offensive, abusive, liable to incite
                racial and/or religious hatred, discriminatory, menacing,
                scandalous, inflammatory, blasphemous, in breach of confidence,
                in breach of privacy and/or which may cause annoyance and/or
                inconvenience;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(g)</p>
              <p style="margin-left: 10px">
                does not constitute and/or encourage conduct that would be
                considered a criminal offence, give rise to civil liability,
                and/or otherwise be contrary to the law;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(h)</p>
              <p style="margin-left: 10px">
                shall not be or include material that is technically harmful
                (including, without limitation, computer viruses, logic bombs,
                Trojan horses, worms, harmful components, corrupted data or
                other malicious software or harmful data) or other computer
                programming routines that may damage, detrimentally interfere
                with, diminish value of, surreptitiously intercept or
                expropriate any system, data or personal information;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(i)</p>
              <p style="margin-left: 10px">
                shall not create liability and/or claims for the Company;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(j)</p>
              <p style="margin-left: 10px">
                shall not be in the nature of political campaigning, commercial
                solicitation, chain letters, mass mailings and/or any form of
                ‘spam’;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(k)</p>
              <p style="margin-left: 10px">
                shall not be illegal in any other way.
              </p>
            </div>
            <div style="display: flex">
              <p>7.4</p>
              <p style="margin-left: 10px">
                The Company reserves the right to remove and/or edit any
                detail/information that the Company in its sole discretion deems
                appropriate. The User confirms that he/she/it shall abide by all
                notices and all the terms and conditions (updated from time to
                time) contained and mentioned herein.
              </p>
            </div>
            <div style="display: flex">
              <p>7.5</p>
              <p style="margin-left: 10px">
                The User undertakes and confirms that the User shall not use the
                Platform, Services and/or materials therein for any purpose that
                is unlawful and/or prohibited by the terms of this Agreement
                and/or under any applicable laws, rulings, notifications, orders
                of any court or statutory authority
              </p>
            </div>
            <div style="display: flex">
              <p>7.6</p>
              <p style="margin-left: 10px">
                The User shall not use the Platform, Services and/or materials
                therein in any manner which could damage, disable, overburden
                and/or impair the Platform and/or any Services therein and/or
                the network(s) connected to the Platform and interfere with
                another User’s use and enjoyment of the Platform and/or Services
                therein.
              </p>
            </div>
            <div style="display: flex">
              <p>7.7</p>
              <p style="margin-left: 10px">
                The User shall not attempt to gain unauthorized access to any
                Service on the Platform, other users’ account(s), computer
                systems and/or networks connected to the Platform through
                hacking, password mining and/or any other means. The User shall
                not attempt to obtain any materials or information through any
                means not intentionally made available to the User through the
                Platform.
              </p>
            </div>
            <div style="display: flex">
              <p>7.8</p>
              <p style="margin-left: 10px">
                The Company shall not be responsible and/or liable for any
                claims, losses and/or damages accruing to or affecting the User,
                as a result of: (i) the User’s access or reliance on any Work
                Assignments appearing on the Platform which are posted by
                Requirement Listing Companies; and/or (ii) the User i.e. IC
                and/or Third Party Service Provider engaging with the
                Requirement Listing Companies in regard to Work Assignments on
                agreed terms; and/or (iii) the User i.e. IC and/or Requirement
                Listing Companies engaging with any Third Party Service
                Provider; and/or (iv) any defects/deficiencies in the services
                provided by any Third Party Service Provider; and/or (v) any
                claims in relation to the payment of any agreed terms between
                the User engaging with each other through the Platform; and/or
                (vi) any claims/actions (including consumer claims) arising
                thereto; and/or (vii) any violation by the Users of the rights
                of third parties, including without limitation, infringement of
                copyright, trademark, service mark, patent, trade secret,
                privacy or other intellectual property or proprietary right or
                misappropriation of any property. The advertisement/advice (if
                any) received via the Platform should not be relied upon for
                personal, legal and/or financial decisions and the User should
                consult an appropriate professional for specific advice tailored
                to your situation.
              </p>
            </div>
            <div style="display: flex">
              <p>7.9</p>
              <p style="margin-left: 10px">
                The User shall be solely responsible for obtaining and
                maintaining any equipment or ancillary services needed to
                connect to, access the Platform or otherwise use the Services,
                including, without limitation, modems, hardware, software, and
                long distance or local telephone service. The User shall be
                responsible for ensuring that such equipment or ancillary
                services are compatible with the Services.
              </p>
            </div>

            <b><li>Payment Terms</li></b>
            <div style="display: flex">
              <p>8.1</p>
              <p style="margin-left: 10px">
                The User shall be entitled to use his/her/its valid credit/debit
                cards, online/net banking facility, tele banking facility to
                make payment for the Subscription Fee for the Platform. The User
                shall be bound to use his/her/its own credit/debit cards, online
                banking accounts to make any payment. The User undertakes and
                confirms that he/she/it would furnish correct, complete and
                accurate detail of credit/debit cards, online banking accounts
                and shall be solely responsible for any cost, expense, loss
                and/or damage which the User may suffer due to furnishing of
                wrong detail/information relating to his/her credit/debit cards
                or online banking accounts.
              </p>
            </div>
            <div style="display: flex">
              <p>8.2</p>
              <p style="margin-left: 10px">
                The Company confirms that the details provided by the User in
                this regard shall be kept confidential and shall not be
                disclosed to any third-party except to the extent required under
                the rules of any stock exchange and/or by applicable laws,
                regulations and/or processes of any government authority and/or
                in connection with any judicial process regarding any legal
                action, suit and/or proceeding arising out of and/or relating to
                this Agreement and/or relating to provision of Services by the
                Company.
              </p>
            </div>
            <div style="display: flex">
              <p>8.3</p>
              <p style="margin-left: 10px">
                The User here represents and acknowledges that all payments made
                by the User to the Company shall be strictly on a non-refundable
                basis and the Subscription Fees paid by a User towards the
                Services are non – refundable and non-transferable.
              </p>
            </div>
            <div style="display: flex">
              <p>8.4</p>
              <p style="margin-left: 10px">
                The Company shall take all reasonable precautions to protect the
                information provided by the User. However, it is expressly
                provided and accepted by the User that the Company shall not be
                responsible in any manner whatsoever for any third-party action
                which results in the information provided by the User being
                exposed, misused and/or fraudulently misused in any manner
                whatsoever by such third- party.
              </p>
            </div>

            <b><li>Force Majeure</li></b>
            <p>
              The Company shall not be liable for any failure and/or delay on
              its part in performing any of its obligation under this Agreement
              and/or for any loss, damage, costs, charges and expenses incurred
              and/or suffered by the User by reason thereof if such failure
              and/or delay shall be result of or arising out of Force Majeure
              Event set out herein. During the continuation of Force Majeure
              Event, the obligations of the Company under the Agreement shall
              stand suspended till ceasing of the Force Majeure Event. The
              Company shall make its best endeavours to resolve any issues in
              regard to Force Majeure Event at the earliest and keep the Users
              updated on the same through notification on the Platform.
            </p>
            <p>
              A “<b>Force Majeure Event</b>” means any event due to any cause
              beyond the reasonable control of the Company, including, without
              limitation, unavailability of any communication system, sabotage,
              fire, flood, earthquake, explosion, acts of God, civil commotion,
              strikes, lockout, and/or industrial action of any kind, breakdown
              of its facilities, riots, insurrection, terrorist attack,
              hostilities whether war be declared or not, acts of government,
              governmental orders or restrictions, pandemics, epidemics,
              breakdown and/or irregularities in networks, bugs, viruses,
              breakdown of software, hacking of the Platform and/or contents
              provided for availing the Services under the Platform.
            </p>

            <b><li>Warranty Disclaimer</li></b>
            <div style="display: flex">
              <p>10.1</p>
              <p style="margin-left: 10px">
                The User acknowledges that the Company has no control over and
                no duty to take any action regarding (i) the User gaining access
                to the Platform and/or its content and/or Services; (ii) what
                effect the Platform and/or its content and/or Services may have
                on the User and/or any third-party; (iii) how the User may
                interpret or use the Platform and/or its content and/or
                Services; (iv) what actions the User may take as a result of
                having been exposed to the Platform and/or its content and/or
                Services. The User releases the Company from all liability
                whether financial or otherwise for the User having accessed the
                Platform and/or its content and/or Services.
              </p>
            </div>
            <div style="display: flex">
              <p>10.2</p>
              <p style="margin-left: 10px">
                The Company provides access to the Platform on an ‘as is’ and
                ‘as available’ basis. Neither does the Company nor do any third
                parties including Third Party Service Providers (except as
                expressly stated by such Third Party Service Provider), provide
                any warranty or guarantee, express or implied, as to the
                accuracy, fitness, merchantability, availability, quality,
                performance, completeness or suitability of the Platform and/or
                its content and/or Services, for any specific purpose. The User
                acknowledges that the Platform and/or its content and/or
                Services may contain inaccuracies or errors and the Company
                expressly excludes liability whether financial or otherwise for
                any such inaccuracies or errors to the fullest extent permitted
                by law.
              </p>
            </div>
            <div style="display: flex">
              <p>10.3</p>
              <p style="margin-left: 10px">
                Although the Company has taken adequate safeguards, the Company
                makes no guarantee of confidentiality and/or privacy of any User
                communication or information transmitted on the Platform and/or
                for the Services and/or on any web-site linked to the Platform.
                The User uses this Platform and/or Services and/or on any
                web-site linked to the Platform at his/her/its own risk.
              </p>
            </div>
            <div style="display: flex">
              <p>10.4</p>
              <p style="margin-left: 10px">
                The Platform and/or its content and/or Services may contain
                views, opinions and recommendations of Users of the Platform
                and/or Services, Third Party Content, User Content, advertisers,
                thirdparty information providers and organizations. The Platform
                does not warrant, represent and/or endorse the correctness,
                authenticity, accuracy, completeness, reliability or validity of
                any such information displayed, uploaded, distributed, posted,
                emailed, transmitted or otherwise contributed through the
                Platform by anybody other than the Company. The Company assumes
                no responsibility to keep the content current, complete,
                up-to-date, valid, or accurate. The Company shall not be
                responsible in any manner whatsoever whether financially or
                otherwise for any errors and omissions in the materials and/or
                content even if such errors or omissions are due to negligence.
                The User acknowledges that any reliance upon any such view,
                opinion, advice, recommendation or information, User Content,
                Third Party Content shall be at the User’s sole risk.
              </p>
            </div>
            <div style="display: flex">
              <p>10.5</p>
              <p style="margin-left: 10px">
                The Company does not warrant the accuracy, reliability,
                credibility or completeness of the Platform and/or its content
                and/or its Services. The Company makes no warranty that its
                Platform and/or its content are appropriate or available for use
                in other locations. Those who access the Platform and/or its
                content from territories other than India shall do so at their
                own risk and hereby unconditionally represent and undertake that
                they are responsible for full compliance with their local laws
                and the applicable laws of the Republic of India.
              </p>
            </div>
            <div style="display: flex">
              <p>10.6</p>
              <p style="margin-left: 10px">
                The User shall be solely responsible to maintain the
                confidentiality and security of his/her/its account, User Id,
                Password, login credentials and the Company shall not be
                responsible for any losses arising out of the unauthorized
                access and/or use of the User’s account as a result of the User
                not following the terms and conditions stated herein.
              </p>
            </div>
            <div style="display: flex">
              <p>10.7</p>
              <p style="margin-left: 10px">
                The Company shall be under no liability whether financial or
                otherwise of any nature whatsoever in respect of any loss,
                damage, claim or fraud suffered directly or indirectly by the
                User as a result of the User viewing, accessing, visiting and/or
                otherwise using the Platform.
              </p>
            </div>
            <div style="display: flex">
              <p>10.8</p>
              <p style="margin-left: 10px">
                The User expressly understands and agrees that the Company, its
                shareholders, associate companies, directors, employees,
                representatives, agents and partners, shall not be liable to the
                User for any direct, indirect, incidental, special,
                consequential, punitive or exemplary damages, including, but not
                limited to, damages for loss of profits, goodwill, use, data, or
                other intangible losses resulting from:
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(a)</p>
              <p style="margin-left: 10px">
                the User’s use or inability to use the Platform;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(b)</p>
              <p style="margin-left: 10px">any changes made to the Platform;</p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(c)</p>
              <p style="margin-left: 10px">
                temporary or permanent cessation of the Platform, the Services,
                the Company’s business or any part thereof;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(d)</p>
              <p style="margin-left: 10px">
                any unauthorized access to or alteration of the User
                transmissions or data, if any;
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(e)</p>
              <p style="margin-left: 10px">
                statements or conduct of any third-party on the Platform; and
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(f)</p>
              <p style="margin-left: 10px">
                any fraud, security breach, misconduct or negligence by any
                third parties and/or advertisers and/or service providers.
              </p>
            </div>
            <div style="display: flex">
              <p>10.9</p>
              <p style="margin-left: 10px">
                The Company does not warrant that access and use of its Platform
                and/or its content and/or Service will be uninterrupted, timely,
                secure and error-free since the same could be affected by
                overload/breakdown of receiving network, servers or
                applications; system failures; and frauds out of the Company’s
                control. The Company shall not be liable for any loss or damage
                whether financial or otherwise caused by a distributed
                denial-of-service attack, viruses or other technologically
                harmful material that may infect the User’s device, programs,
                data or other proprietary material due to use of the Platform.
              </p>
            </div>
            <div style="display: flex">
              <p>10.10</p>
              <p style="margin-left: 10px">
                The Company does not endorse in anyway any contents of the work
                profiles of ICs enrolled on its Platform and/or Work Assignments
                listed by the Requirement Listing Companies and/or service
                profiles listed by Third Party Service Providers. The User i.e.
                Requirement Listing Companies shall verify the veracity of all
                information on his/her own before undertaking reliance and
                acting thereupon. The User expressly agrees and understands that
                the Services, materials, consultations, content and information
                offered on the Platform is not a substitute for professional
                advice and the Company disclaims all liability whether financial
                or otherwise for any claims arising thereto.
              </p>
            </div>
            <div style="display: flex">
              <p>10.11</p>
              <p style="margin-left: 10px">
                The Company is not responsible for the availability or content
                of any third-party material you access through the Platform. The
                Company does not endorse and is not responsible or liable for
                any content, advertising, products, services or information of
                or relating to a third-party (including payment for and delivery
                of such products or services). The Company shall not be
                responsible for any damage, loss or offence caused by or, in
                connection with, any content, material, advertising, products,
                services or information of any third-party that may be available
                on the Platform. Any terms, conditions, warranties or
                representations associated with such dealings, are solely
                between the User and the relevant provider of the service and
                the User agrees to indemnify the Company for any claims arising
                thereto
              </p>
            </div>
            <div style="display: flex">
              <p>10.12</p>
              <p style="margin-left: 10px">
                The Company shall not be responsible and/or liable whether
                financially or otherwise in any manner whatsoever for any
                third-party action which results in the information provided by
                the User being exposed, misused and/or by such third-party who
                accessed such information without any authorization from the
                Company.
              </p>
            </div>
            <div style="display: flex">
              <p>10.13</p>
              <p style="margin-left: 10px">
                The Company may use a third-party as a payment gateway. By
                subscribing to the Company’s Services, the User expressly
                authorizes a third-party payment gateway to charge the User’s
                credit card/debit card. The Company disclaims any and all
                liability accruing to the User as a result of any fraud, misuse
                and/or duplicate transactions arising thereto.
              </p>
            </div>
            <div style="display: flex">
              <p>10.14</p>
              <p style="margin-left: 10px">
                The Company neither warrants nor represents that use of the
                Services by the User will not infringe the rights of third
                parties not owned by or affiliated with the Company.
              </p>
            </div>
            <div style="display: flex">
              <p>10.15</p>
              <p style="margin-left: 10px">
                There may be delay in provision of Services due to factors
                beyond the reasonable control of the Company and therefore the
                Company shall not be held responsible and liable for any delay
                and/or failure in performance of Services by the Company due to
                such factors. The Platform may be subject to changes and/or
                improvements periodically. During the process of up-gradation,
                repair, maintenance and/or improvements,
                contents/systems/programs/software may be suspended for any use.
                The Company shall not be liable for any inconvenience, loss,
                damage, cost, expenses which may be incurred by the User due to
                unavailability of the Platform for any use. The Company does not
                warrant that the software will work on all networks and/or will
                be available in all geographical areas.
              </p>
            </div>

            <br /><b
              ><li>Personal, Non-Commercial and Non-Assignable Use</li></b
            >
            <p>
              By registering on the Platform the User confirms that use of the
              Platform shall be for his/her personal and/or commercial purpose
              (as may be applicable). The User confirms that the User’s right to
              access, use, deal with or transact at the Platform cannot be
              assigned to any other person and custody of the User Id and
              Password to access, deal with or transact at the Platform shall be
              the sole responsibility of the User and the User shall be
              responsible and liable for any misuse of the User Id and Password
              assigned to the User by the Company.
            </p>

            <b><li>Privacy Policy</li></b>
            <p>
              Privacy Policy of the company can be accessed here (Link to
              Privacy Policy to be inserted)
            </p>

            <b><li>Links to other Platforms</li></b>
            <p>
              The Platform may contain hyperlinks to Platforms operated by
              persons other than the Company (hereinafter referred to as the “<b
                >Web Links</b
              >”). Such Web Links are provided for the User’s reference and
              convenience only and they do not constitute as any recommendation
              and/or advice and should not be relied upon in making and/or
              refraining from making any decision. The Company reserves its
              right to remove any such Web Links anytime without any prior
              notice. The Company is not under obligation to review the contents
              of Web Links and therefore does not control the contents of those
              Web Links. The User leaves the Platform by clicking on Web Links
              and goes to respective internet Platforms and use of those Web
              Links shall be regulated by terms provided on respective
              Platforms. The Company is neither acting as publisher of contents
              of those Web Links nor endorser of any representation published on
              those Web Links. The User confirms that any access of Web Links by
              the User shall be entirely at the User’s own risk.
            </p>

            <b><li>Description and Fees</li></b>
            <p>
              The Company shall endeavor to the best extent possible to be as
              accurate while providing Service descriptions and fees. However,
              the Company does not warrant that descriptions and/or other
              content and/or fees related to the Services and/or other
              information and content contained in this Platform is accurate,
              complete, reliable, current and error-free.
            </p>

            <b><li>Promotional Material</li></b>
            <p>
              The Company shall be entitled to send and the User gives his/her
              consent to receive, information/ offers/ promotional mails and
              messages pertaining to the Services offered by the Company/the
              associate companies from time to time.
            </p>
            <p>
              In case the User wishes to deactivate any promotional material
              being provided to the User, the User shall notify the Company at
              <a href="mailto:complaints@gig4ce.com"
                ><u> complaints@gig4ce.com </u></a
              >
            </p>

            <b><li>Indemnity and Limitation of Liability</li></b>
            <p>
              Without prejudice to the rights of the Company under law, in
              equity and/or under this Agreement, the User agrees to protect,
              hold harmless and indemnify the Company, its shareholders,
              associate companies, directors, employees, representatives, agents
              and partners, to the fullest extent, from and against any and all
              claims, demands, damages, obligations, losses, liabilities,
              judgments, settlements, costs and expenses (including reasonable
              attorneys’ fees and costs) arising from or relating to: (i) the
              User’s access, use or misuse of the Platform; and/or (ii) the
              User’s breach or alleged breach of this Agreement and/or breach of
              the User’s representations, warranties, guarantees, covenants,
              obligations and undertakings; and/or (iii) any violation by the
              User of any applicable laws; and/or (iv) any violation by the User
              of the Company’s rights and/or the rights of third parties,
              including without limitation, infringement of copyright,
              trademark, service mark, patent, trade secret, privacy or other
              intellectual property or proprietary right or misappropriation of
              any property.
            </p>
            <p>
              Notwithstanding anything contained in the Agreement, the maximum
              liability of the Company for rendering the Services, whether
              financial or otherwise for any reasons whatsoever under the
              Agreement shall not exceed the Subscription Fees received by the
              Company from any User under the Agreement.
            </p>

            <b><li>Termination</li></b>
            <div style="display: flex">
              <p>17.1</p>
              <p style="margin-left: 10px">
                The Company may, at any time, terminate or suspend any and all
                Services and/or access to the Platform immediately, without
                prior notice and/or liability if:
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(a)</p>
              <p style="margin-left: 10px">
                The User breaches any of the terms or conditions of this
                Agreement and/or other incorporated agreements and/or
                guidelines.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(b)</p>
              <p style="margin-left: 10px">
                Requests by law enforcement and/or other government agencies.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(c)</p>
              <p style="margin-left: 10px">
                Discontinuance and/or material modification to the Platform
                and/or Service (or any part thereof).
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(d)</p>
              <p style="margin-left: 10px">
                Unexpected technical and/or security issues and/or problems.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(e)</p>
              <p style="margin-left: 10px">
                Engagement by the User in fraudulent and/or illegal activities
                and/or suspected impersonation and/or due to result of any
                background search and/or credit check conducted on the User
                and/or any breach or threatened breach/ infringement of
                Intellectual Property Rights of the Company.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(f)</p>
              <p style="margin-left: 10px">
                Non - payment of Subscription Fees owed by the User in
                connection with the use of Platform and/or Services.
              </p>
            </div>
            <div style="display: flex">
              <p>17.2</p>
              <p style="margin-left: 10px">
                Termination of the User account includes:
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(a)</p>
              <p style="margin-left: 10px">
                Removal of access to all offerings within the Service and the
                Platform.
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(b)</p>
              <p style="margin-left: 10px">
                Deletion of the User Id and Password and all related
                information, files and content associated with or inside the
                User account (or any part thereof).
              </p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>(c)</p>
              <p style="margin-left: 10px">
                Barring further use of the Platform and/or Service.
              </p>
            </div>
            <div style="display: flex">
              <p>17.3</p>
              <p style="margin-left: 10px">
                The User hereby agrees that all terminations for cause shall be
                made in Company’s sole discretion and that Company shall not be
                liable to the User or any third-party for any termination of the
                User account, any associated email address, or access to the
                Services. Any Subscription Fees paid hereunder are
                non-refundable. All provisions of this Agreement which by their
                nature should survive termination shall survive termination,
                including, without limitation, ownership provisions and warranty
                disclaimers.
              </p>
            </div>

            <b><li>Governing Law</li></b>
            <p>
              This Agreement shall be governed by, construed, interpreted, and
              enforced in accordance with the laws of India. Except for
              injunctive reliefs, specific performance and damages any other
              disputes arising in respect hereto shall be subject to exclusive
              jurisdiction of the Courts of Delhi.
            </p>

            <b><li>General Provisions</li></b>
            <div style="display: flex">
              <p>19.1</p>
              <p style="margin-left: 10px"><b>No Partnership</b></p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>
                None of the provisions of this Agreement shall be deemed to
                constitute a partnership or agency between the User and the
                Company and the User shall have no authority to bind the Company
                in any manner whatsoever.
              </p>
            </div>
            <div style="display: flex">
              <p>19.2</p>
              <p style="margin-left: 10px"><b>Electronic communication</b></p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>
                The User consents and gives his/her consent to receive
                communications from the Company electronically/through
                electronic records. The Company will communicate with the User
                by email and/or by posting notices on this Platform. The User
                agrees that all agreements, notices, disclosures and other
                communications that the Company provides to the User
                electronically satisfy all legal requirements of adequate
                service of notice/electronic record. This document is an
                electronic record in terms of Information Technology Act, 2000.
                This electronic record is generated by a computer system and
                does not require any physical and/or digital signatures.
              </p>
            </div>
            <div style="display: flex">
              <p>19.3</p>
              <p style="margin-left: 10px"><b>Assignment</b></p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>
                The Company can assign its rights and/or obligations provided
                herein or arising out of this Agreement to any person. The User
                cannot assign its rights and remedies and/or transfer its
                obligations under this Agreement without prior written consent
                of the Company.
              </p>
            </div>
            <div style="display: flex">
              <p>19.4</p>
              <p style="margin-left: 10px"><b>Severability</b></p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>
                Should any provision of this Agreement be determined to be
                unenforceable and/or invalid, or any transaction contemplated
                hereby determined to be unlawful by any court of law, or
                competent government body for any reason, all other provisions
                shall continue (except if this Agreement stands terminated) in
                full force and effect.
              </p>
            </div>
            <div style="display: flex">
              <p>19.5</p>
              <p style="margin-left: 10px"><b>Grievances</b></p>
            </div>
            <div style="display: flex; margin-left: 30px">
              <p>
                In case of any queries and/or grievances and/or assistance
                required, if any, the User can reach out to Mr Anirudh Syal our
                Grievance Redressal Officer, email us all queries and/or
                complaints on
                <a href="mailto:complaints@gig4ce.com"
                  ><u> complaints@gig4ce.com </u></a
                >
              </p>
            </div>
          </ol>
        </ol>
      </div>
    </div>
    <!-- <my-footer></my-footer> -->
  </div>
</template>
<script>
// import header from "../components/Header";
// import footer from "../components/Footer";

export default {
  components: {
    // myFooter: footer,
    // myHeader: header,
  },
  data: () => ({
    html: ``,
    mainList: ["Recitals"],
    details: {
      recitals: [
        "This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology (Amendment) Act, 2008. This electronic record is generated by a computer system and does not require any physical or digital signatures. This electronic record is generated by a computer system and does not require any physical or digital signatures.",
        "This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries Guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and user agreement for access or usage of www.gig4ce.com. [SAM & Co. Notes: Please confirm the domain name]",
        "www.gig4ce.com (“Website”) and our application gig4ce (jointly referred to as “Platform”) is owned and operated by Gigforce Private Limited, a company incorporated under the Companies Act, 2013 vide CIN - U74999HR2019PTC082217, having its corporate office at House no 1872 Sector-2 BALLABHGARH Faridabad HR 121004 IN [SAM& Co. Note: Please confirm the same] hereinafter referred to as the “Company” (which expression shall, unless it be repugnant to the context or meaning thereof, include its successors and assigns).",
        `Subject to the terms and conditions of this Agreement (as defined hereinafter), the Company shall make available through the Platform being an online aggregator platform and connecting medium for (i) persons to provide their work profiles, availability status and interest areas for rendering services in specific areas in time bound manner (“Independent Consultants” or “IC”); (ii) for corporate entities to provide their requirements of availing services of IC’s on specific assignments (“Work Assignments”) in regard to their business establishment (“Requirement Listing Companies”); (iii) third party service provider entities who are interested in rendering services including skill improvement seminars, e-workshops for enhancing professional skills, preparation of IC’s for interview and finalising of their work profile, insurances and social security, payroll services, pay roll compliance services, staffing service providers, legal and account related services, credit score checks and background checks  etc. (“Third Party Service Providers”) making available the information being uploaded by IC, Requirement Listing Companies and Third Party Service Providers and enabling parties to have better access to services and/or service providers in consideration of the subscription fee which may be fixed by the Company from time to time and reflected on the Platform while availing the services and as may be charged by the Company at its sole discretion from time to time (“Subscription Fees”) on the terms and conditions set out herein (“Services”). `,
        `It is expressly clarified that the Company may render certain specific Services without any charges for a specific time period as may be deemed fit by the Company and which shall be notified on the Platform from time to time. It is expressly stated that the User shall be solely responsible and liable for the information, images and data uploaded by the User.. The Company has the absolute right, at any time, to render the Services being offered through the Platform through any party whatsoever.`,
        `Use of this Platform is regulated by terms and conditions provided herein. By clicking on the “I ACCEPT” button, you are consenting to be bound by these Agreement and please ensure that you read and understand all these user terms before you use the Platform. If you do not accept any of the user terms, then please do not use the site or avail any of the services being provided therein. Your agreement to these user terms shall operate as a binding agreement between you and the Company in respect of the use and services of the Platform. Your access, visit, dealing, transacting and/or otherwise using this Platform shall be treated as your unconditional acceptance of these terms in entirety and the same shall be deemed that you have accepted these terms fully and you have gone through and understood these terms completely and these terms shall be treated as a legally binding and enforceable Agreement between the Company and you (“Acceptance”). If you do not agree with any of these terms or all of these terms, then you should stop dealing with and/or not initiate or undertake any transaction on this Platform.`,
        `The information and Services offered on this Platform or through other mediums should not be considered as a substitute for professional advice. The User's use of the Platform and/or Services is subject to the additional disclaimers and caveats that may appear throughout the Platform. The Company, its associate companies, subsidiaries assume no responsibility for any consequence relating directly and/or indirectly to any action and/or inaction that the User takes based on the information, Services and other materials on this Platform. While the Company strives to keep the information relating to the various Services offered on this Platform accurate, complete and up-to-date, the Company, its subsidiaries, affiliates, associate companies, consultants, partners, agents and suppliers cannot guarantee, and will not be responsible for any damage and/or loss related to, the accuracy, completeness or timelines of the information.</br></br> It is expressly provided that the data pertaining to the Services offered through the Platform is provided by third parties and the same is not owned by the Company.`,
        `The Company may change, suspend and/or discontinue the Services at any time, including the availability of any feature, database and content on the Platform. The Company may also impose limits on certain features and Services and/or restrict the User's access to parts and/or all of the Services without notice and/or liability to the Users.`,
        `All kind of correspondence should be addressed to Company’s office address as given above.`,
      ],
    },
  }),
  methods: {
    makeHtml() {
      this.html = `<ol type="I">`;
      this.mainList.forEach((item) => {
        this.html += `<li> <span class="is-size-4">${item}</span>`;
        this.html += `<ol>`;
        this.details[item.toLowerCase()].forEach((text) => {
          this.html += `<li class="is-size-6">${text}</li>`;
        });
        this.html += `</ol></li>`;
      });
      this.html += `</ol>`;
    },
  },
  mounted() {
    this.makeHtml();
  },
};
</script>
<style>
.top-margin {
  margin-top: 7rem;
}
ul {
  list-style: disc;
  margin-left: 10px;
}

@media only screen and (max-width: 768px) {
  .container {
    margin: 8%;
  }
}
</style>